import http from './cart/http.service';

export const productoService = {
    buscar,
    buscarAdmin,
    addEdit,
    addEditAdmin,
    grabarRepuestosBaja,
    grabarRepuestosBajaAdmin,
    eliminar,
    borrarImagen,
    borrarImagenAdmin,
    reordenarImagenes,
    reordenarImagenesAdmin,
    subirImagen,
    crearPreferencia,
    buscarRepuestosBaja,
    crearCompraCash
};


function buscarRepuestosBaja(data) {
    const url = '/public/producto/buscarRepuestosBaja';
    return http.post(url, JSON.stringify(data));
}


function crearCompraCash(data) {
    const url = '/api/ventas/crearCompraCash';
    return http.post(url, JSON.stringify(data));
}

function crearPreferencia(data) {
    const url = '/api/ventas/crearPreference';
    return http.post(url, JSON.stringify(data));
}

function buscar(data) {
    const url = '/api/vendedor/producto/buscar';
    return http.post(url, JSON.stringify(data));
}

// El back office usa /api/admin/producto: mismas operaciones pero sobre las
// publicaciones de cualquier vendedor (el vendedor viaja en el propio DTO).
function buscarAdmin(data) {
    const url = '/api/admin/producto/buscar';
    return http.post(url, JSON.stringify(data));
}

function addEditAdmin(data) {
    const url = '/api/admin/producto/add';
    return http.post(url, JSON.stringify(data));
}

function grabarRepuestosBajaAdmin(data, vendedorId) {
    const url = `/api/admin/producto/baja/add?vendedorId=${vendedorId}`;
    return http.post(url, JSON.stringify(data));
}

function addEdit(data) {
    const url = '/api/vendedor/producto/add';
    return http.post(url, JSON.stringify(data));
}

function grabarRepuestosBaja(data) {
    const url = '/api/vendedor/producto/baja/add';
    return http.post(url, JSON.stringify(data));
}


function eliminar(id) {
    const url = `/api/${id}`;
    return http.delete(url);
}

// El form sube las fotos de a una dentro del propio POST de la publicacion; para sacarlas
// hace falta este endpoint, porque ya no alcanza con pisar la ranura del mismo tipo.
function borrarImagen(productoId, imagenId) {
    const url = `/api/vendedor/producto/${productoId}/imagen/${imagenId}`;
    return http.delete(url);
}

function borrarImagenAdmin(productoId, imagenId) {
    const url = `/api/admin/producto/${productoId}/imagen/${imagenId}`;
    return http.delete(url);
}

// El orden de la galeria lo elige el vendedor arrastrando las fotos; viaja como la lista
// de ids de imagen tal cual quedaron.
function reordenarImagenes(productoId, imagenIds) {
    const url = `/api/vendedor/producto/${productoId}/imagenes/orden`;
    return http.put(url, JSON.stringify(imagenIds));
}

function reordenarImagenesAdmin(productoId, imagenIds) {
    const url = `/api/admin/producto/${productoId}/imagenes/orden`;
    return http.put(url, JSON.stringify(imagenIds));
}

function subirImagen(id, file) {
    const url = `/api/candado/subirImagen/${id}`;
    const formData = new FormData();
    formData.append('file', file);

    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };

    return http.post(url, formData, config);
}
